const getArrayWithType = (data, arrType) => {
    if (Array.isArray(data)) {
        return data.map((_) => arrType(_));
    }
    else if (data === 0 || !!data) {
        return [arrType(data)];
    }
    else {
        return undefined;
    }
};

export { getArrayWithType };
//# sourceMappingURL=getArrayWithType.js.map
